module.exports = __webpack_public_path__ + "img/lang.95479bbc.png";